(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["responsive-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kyoto-responsive-video-v3')) {
    customElements.define('kyoto-responsive-video-v3', class extends HTMLElement {
      connectedCallback() {
        this.breakpoint = window.matchMedia('(max-width: 767px)');
        this.onChange = () => this.renderVideo();
        this.breakpoint.addEventListener('change', this.onChange);
        this.renderVideo();
      }

      disconnectedCallback() {
        this.breakpoint.removeEventListener('change', this.onChange);
        this.querySelectorAll('video').forEach(video => video.pause());
      }

      renderVideo() {
        const device = this.breakpoint.matches ? 'mobile' : 'desktop';
        this.querySelectorAll('[data-device]').forEach(container => {
          const video = container.querySelector('video');
          if (!video) return;
          if (container.dataset.device !== device) {
            video.pause();
            return;
          }
          if (this.dataset.autoplay === 'true') {
            video.muted = true;
            const playback = video.play();
            if (playback) playback.catch(() => {});
          } else {
            video.pause();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
